import api from "utils/api";

export const SHOP_BASKET_KEY = "hoffmann-shop-basket";
export const SHOP_BASKET_EVENT = "hoffmann-shop-basket-change";
export const SHOP_GUEST_EMAIL_KEY = "hoffmann-shop-guest-email";

export const normalizeShopEmail = (value) =>
  String(value || "").trim().toLowerCase();

export const isValidShopEmail = (value) => {
  const email = normalizeShopEmail(value);
  return email.length <= 120 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const readShopGuestEmail = () => {
  try {
    return window.sessionStorage.getItem(SHOP_GUEST_EMAIL_KEY) || "";
  } catch {
    return "";
  }
};

export const writeShopGuestEmail = (value) => {
  try {
    window.sessionStorage.setItem(SHOP_GUEST_EMAIL_KEY, value);
  } catch {
    /* Der Kauf bleibt auch ohne Session-Speicher möglich. */
  }
};

export const readShopBasket = () => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(SHOP_BASKET_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const writeShopBasket = (items) => {
  const next = Array.isArray(items) ? items : [];
  window.localStorage.setItem(SHOP_BASKET_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(SHOP_BASKET_EVENT, { detail: next }));
  return next;
};

export const voucherBalanceBreakdown = (totalCents, balanceCents, applyBalance) => {
  const total = Math.max(0, Math.round(Number(totalCents) || 0));
  const available = Math.max(0, Math.round(Number(balanceCents) || 0));
  let balanceAppliedCents = applyBalance ? Math.min(total, available) : 0;
  if (total - balanceAppliedCents > 0 && total - balanceAppliedCents < 50) {
    balanceAppliedCents = Math.max(0, total - 50);
  }
  return { balanceAppliedCents, amountDueCents: total - balanceAppliedCents };
};

export const checkoutVoucherItems = async (items, purchaserEmail, applyBalance = false) => {
  const email = purchaserEmail === undefined ? undefined : normalizeShopEmail(purchaserEmail);
  if (email !== undefined && !isValidShopEmail(email)) {
    throw new Error("Bitte gib eine gültige E-Mail-Adresse für den Kauf an.");
  }
  const { data } = await api.post("/vouchers/checkout", {
    items,
    applyBalance: Boolean(applyBalance),
    ...(email !== undefined ? { purchaserEmail: email } : {}),
  });
  if (!data?.url && !data?.confirmed) {
    throw new Error("Die Zahlungsseite konnte nicht geöffnet werden.");
  }
  return data;
};
